import React, { useState } from "react";
import algo from "../assets/network.gif";

function Community() {
  const potentialPoints = [
    "They advance their goals",
    "You earn new vaults",
    "The community grows stronger",
    "Causes get funded",
  ];
  return (
    <section>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="pt-12 md:py-20 border-t border-gray-800">
          {/* Items */}
          <div className="flex flex-col justify-center items-center">
            {/* Item */}
            <div className="md:grid md:grid-cols-12 md:gap-6 flex flex-col justify-center items-center">
              <div
                className="max-w-xl md:max-w-none md:w-full mx-auto md:col-span-5 lg:col-span-6 mb-0 md:rtl flex flex-col justify-center items-center"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <img
                  className="md:mb-0 mb-10"
                  src={require(`../images/phone/contribute.png`).default}
                  alt="phone-orgs"
                />
              </div>

              <div
                className="max-w-xl md:max-w-none md:w-full mx-auto md:col-span-7 lg:col-span-6"
                data-aos="fade-up"
              >
                <div
                  className="text-xxl h1 mb-8 text-white md:text-left text-center"
                  data-aos="fade-up"
                >
                  Everyone Wins When the Community Gives
                </div>
                <div
                  className="text-3xl text-white md:text-left text-center mb-10 "
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  This isn't charity - it's a peer-to-peer network where givers
                  support each other's goals. When you gift gems to fellow
                  community members:
                </div>
                <ul
                  className="text-3xl text-white mb-8 space-y-4 list-none pl-4"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  {potentialPoints.map((point, index) => (
                    <li key={index} className="flex items-start">
                      <span className="text-primary-1 mr-2">•</span>
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Community;
